module.exports = __webpack_public_path__ + "static/media/lattes_avatar_preto.c89da860.png";